/**
 * 2021-08-18: Currently since this was just implemented, it's
 * developed for DSEC events only, but this could/should be
 * implemented for all front-end permisions eventually.
 * Follow the pattern for DSEC below. Implement contextual permissions object.
 * Add to permissions nested array/object.
 *
 * 2021-09-24: This needs to be re-implemented for asynchronous functionality.
 *
 */

const EventTrackerPermissions = {};

EventTrackerPermissions.KEY = "dsec_calendar";

EventTrackerPermissions.isEventTrackerAdmin = ($auth, $store, data) => {
  return $auth.check("event_tracker_admin") || $auth.check("uber_admin");
}

EventTrackerPermissions.isEventTrackerAdminViewer = ($auth, $store, data) => {
  return $auth.check("event_tracker_admin_viewer") || $auth.check("event_tracker_admin") || $auth.check("uber_admin");
}

EventTrackerPermissions.isPartner = ($auth, $store, data) => {
  return $auth.user().dsec_partners.length > 0;
}

EventTrackerPermissions.isDSEC = ($auth, $store, data) => {
  return $store.state.dsec_event_tracker;
}

EventTrackerPermissions.create = ($auth, $store, data) => {
  return EventTrackerPermissions.isDSEC($auth, $store, data) &&
  (
    EventTrackerPermissions.isEventTrackerAdmin($auth, $store, data) ||
    EventTrackerPermissions.isPartner($auth, $store, data)
  );
}

EventTrackerPermissions.retrieve = ($auth, $store, data) => {
  return EventTrackerPermissions.isDSEC($auth, $store, data);
}

EventTrackerPermissions.update = ($auth, $store, data) => {
  return EventTrackerPermissions.isDSEC($auth, $store, data) &&
  (
    EventTrackerPermissions.isEventTrackerAdmin($auth, $store, data) ||
    EventTrackerPermissions.isPartner($auth, $store, data)
  );
}

EventTrackerPermissions.delete = ($auth, $store, data) => {
  return EventTrackerPermissions.isDSEC($auth, $store, data) &&
  (
    EventTrackerPermissions.isEventTrackerAdmin($auth, $store, data) ||
    EventTrackerPermissions.isPartner($auth, $store, data)
  );
}

const permissionDefinitions = {
  "administer": EventTrackerPermissions.isEventTrackerAdmin,
  "navigate": EventTrackerPermissions.isDSEC,
  "create": EventTrackerPermissions.create,
  "add": EventTrackerPermissions.create,
  "retrieve": EventTrackerPermissions.retrieve,
  "list": EventTrackerPermissions.retrieve,
  "view": EventTrackerPermissions.retrieve,
  "admin_view": EventTrackerPermissions.isEventTrackerAdminViewer,
  "update": EventTrackerPermissions.update,
  "edit": EventTrackerPermissions.update,
  "delete": EventTrackerPermissions.delete
};

var permissions = {};
permissions[EventTrackerPermissions.KEY] = permissionDefinitions;

export default {
  created: function() {
    // console.log('EventTrackerPermissions created', this.application_user_permissions);
  },
  data: function() {
    return {
      application_user_permissions: permissions
    }
  },
  methods: {
    // Event Tracker admin check.
    isEventTrackerAdmin() {
      return EventTrackerPermissions.isEventTrackerAdmin(this.$auth);
    }
  }
};
